import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import AppsApi from 'resources/Organization/Apps/AppsApi';
import { isBlank } from 'utils/isBlank';

import AppDetails from '../../Apps/AppDetailsStrategies';

import AppsPopoverDialog from './AppsPopoverDialog';
import { appEnabledWithLaunchDarkly } from './Utils';

const getAppInfo = (appName) => AppDetails[appName].previewInfo;

const EXCLUDED_APPS = ['Flat rate pricing'];

const APP_SHORTCUT_URLS = {
  reviews: '/pro/apps/reviews',
  'service plans': '/app/service_agreements/',
  'sales proposal tool': '/pro/proposals',
  checklists: '/app/checklist_templates',
  mailchimp: '/pro/integrations/mailchimp',
  'property profile': '/app/equipment',
  'job fields': '/app/job_fields',
};

const appsWithShortcutUrls = (apps) => {
  const appsCopy = [...apps];

  appsCopy.forEach((app, index) => {
    const appCopy = { ...app };
    const appInfo = getAppInfo(app.app.toLowerCase());
    const appName = appInfo.name.toLowerCase();

    if (Object.keys(APP_SHORTCUT_URLS).includes(appName)) {
      const shortCutUrl = APP_SHORTCUT_URLS[appName];
      appCopy.link_to_app = shortCutUrl;
      appsCopy[index] = appCopy;
    }
  });

  return appsCopy;
};

const AppsPopoverContainer = ({ open, onPopoverClose, anchorEl }) => {
  const launchDarklyFlags = useFlags();
  const [apps, setApps] = useState([]);

  const appsToDisplay = apps.filter((app) => {
    const appInfo = getAppInfo(app.app.toLowerCase());
    const featureEnabled = appEnabledWithLaunchDarkly(launchDarklyFlags, appInfo);

    return featureEnabled && !EXCLUDED_APPS.includes(appInfo.name);
  });

  useEffect(() => {
    if (open && isBlank(apps)) {
      AppsApi.getActiveApps().then((response) => {
        const activeApps = response.data.apps;
        const appsWithUrls = appsWithShortcutUrls(activeApps);
        setApps(appsWithUrls);
      });
    }
  }, [apps, open]);

  return <AppsPopoverDialog open={open} onClose={onPopoverClose} apps={appsToDisplay} anchorEl={anchorEl} />;
};

AppsPopoverContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.element,
  onPopoverClose: PropTypes.func.isRequired,
};

export default AppsPopoverContainer;
